import React from 'react';
import { blogPosts } from '../../../data/blogData';
import { services } from '../../../data/site';
import SectionIntro from '../../primitives/SectionIntro';
import Button from '../../primitives/Button';
import ArticleList from '../shared/ArticleList';

// The opening article from each service's category
const latest = services.map(s => ({ ...blogPosts[s.blogCategory][0], categoryId: s.blogCategory }));

const Insights = ({ index = '06' }) => (
  <section className="section">
    <div className="container-site">
      <SectionIntro
        index={index}
        label="Insights"
        title="Insights & *resources*"
        aside={<Button to="/blog" variant="secondary" arrow>All articles</Button>}
      >
        Explore our latest thoughts on AI-powered solutions, digital transformation, and enterprise technology.
      </SectionIntro>
      <div className="mt-[clamp(3rem,6vw,5rem)]">
        <ArticleList posts={latest} />
      </div>
      <div className="mt-10 lg:hidden">
        <Button to="/blog" variant="secondary" arrow>All articles</Button>
      </div>
    </div>
  </section>
);

export default Insights;
